import * as components from "colbi_web_ui/lib/components";
import * as customComponents from "../components/index";

export function changeDeepObject(obj, argsToChange, paramOptions = {}) {
    const allComponents = { ...components, ...customComponents };
    for (let key in obj) {
        if (typeof obj[key] === "object") {
            //go deep in obj with N deep objects
            changeDeepObject(obj[key], argsToChange, paramOptions);
        }
        if (argsToChange.includes(key)) {
            //manipulate obj
            switch (typeof obj[key]) {
                case "object":
                    if (Array.isArray(obj[key])) {
                        obj[key] = obj[key].map((elem) =>
                            extratedValues(elem, allComponents, paramOptions),
                        );
                        obj["props"] = {
                            ...obj["props"],
                            alternativeProps: paramOptions[obj[key]],
                        };
                    }
                    break;
                case "string":
                    if (extratedValues(obj[key], allComponents, paramOptions) !== undefined) {
                        obj["props"] = {
                            ...obj["props"],
                            alternativeProps: paramOptions[obj[key]],
                        };
                        obj[key] = extratedValues(obj[key], allComponents, paramOptions);
                    }
                    break;
                default:
                    break;
            }
        }
    }
}

export function extratedValues(valueToChange, evaluatedData) {
    //TODO: 2/3 arguments
    const match = /\((.*)\)/gm.exec(valueToChange);

    if (match && match[1]) {
        return valueToChange.replace(match[1], deepValue(evaluatedData, match[1]));
    } else {
        return deepValue(evaluatedData, valueToChange);
    }
}

export function deepValue(obj, path) {
    if (!path) return undefined;
    return path.split(".").reduce((a, v) => {
        return a ? a[v] : undefined;
    }, obj);
}
